/*                                    */
import { block, branch, effect, destroy_effect } from '../../reactivity/effects.js';

/*                                                                      */
/*                                                                     */
/*                                                */

/**
 *
 *
 */
export function attach(node, get_fn) {
	/*                                                        */
	var fn = undefined;

	/*                        */
	var e;

	block(() => {
		if (fn !== (fn = get_fn())) {
			if (e) {
				destroy_effect(e);
				e = null;
			}

			if (fn) {
				e = branch(() => {
					effect(() => /*                                  */ (fn)(node));
				});
			}
		}
	});
}
